"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../../enums");

var parser_configuration_1 = require("../parser-configuration");

var BrowserRichTextParser =
/** @class */
function () {
  function BrowserRichTextParser() {}

  BrowserRichTextParser.prototype.resolveRichTextField = function (html, fieldName, replacement, config) {
    try {
      var doc = this.createWrapperElement(html); // get all linked items

      var result = this.processRichTextField(fieldName, doc.children, replacement, config, {
        links: [],
        linkedItems: [],
        images: []
      });
      return {
        links: result.links,
        linkedItems: result.linkedItems,
        images: result.images,
        resolvedHtml: doc.innerHTML
      };
    } catch (error) {
      throw Error('Parsing HTML failed:' + error);
    }
  };

  BrowserRichTextParser.prototype.createWrapperElement = function (html) {
    var element = document.createElement(parser_configuration_1.parserConfiguration.linkedItemWrapperElem);
    element.innerHTML = html;
    return element;
  };

  BrowserRichTextParser.prototype.processRichTextField = function (fieldName, htmlCollection, replacement, config, result) {
    if (!htmlCollection || htmlCollection.length === 0) {// there are no more nodes
    } else {
      // extract objects
      for (var i = 0; i < htmlCollection.length; i++) {
        var element = htmlCollection[i];
        var typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined; // process linked items (modular items)

        if (element.attributes && typeAttribute && typeAttribute.value && typeAttribute.value.toLowerCase() === parser_configuration_1.parserConfiguration.modularContentElementData.type.toLowerCase()) {
          var dataCodenameAttribute = element.attributes.getNamedItem(parser_configuration_1.parserConfiguration.modularContentElementData.dataCodename);
          var dataTypeAttribute = element.attributes.getNamedItem(parser_configuration_1.parserConfiguration.modularContentElementData.dataType);

          if (!dataTypeAttribute) {
            throw Error('Missing data type attribute. This is likely an error caused by invalid response.');
          }

          var linkItemContentObject = {
            dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
            dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
          }; // add to result

          result.linkedItems.push(linkItemContentObject); // replace html

          var parentElement = element.parentElement;

          if (!parentElement) {
            console.warn("Could not replace linked item '" + linkItemContentObject.dataCodename + "' of '" + linkItemContentObject.dataType + "' because parent node is undefined. Please report this error if you are seeing this.");
          } else {
            // create new element
            var newElem = document.createElement(config.linkedItemWrapperTag); // get type of resolving item

            var type = void 0;

            if (dataTypeAttribute.value === 'item') {
              type = enums_1.RichTextContentType.Item;
            } else {
              throw Error("Unknown data type '" + type + "' found in rich text field.");
            }

            newElem.innerHTML = replacement.getLinkedItemHtml(linkItemContentObject.dataCodename, type); // add classes

            newElem.className = config.linkedItemWrapperClasses.map(function (m) {
              return m;
            }).join(' '); // replace original node with new one

            parentElement.replaceChild(newElem, element);
          }
        } // process links


        if (element.nodeName.toLowerCase() === parser_configuration_1.parserConfiguration.linkElementData.nodeName.toLowerCase()) {
          var dataItemIdAttribute = element.attributes.getNamedItem(parser_configuration_1.parserConfiguration.linkElementData.dataItemId);

          if (!dataItemIdAttribute) {
            throw Error("HTML node is invalid. Reason: missing '" + parser_configuration_1.parserConfiguration.linkElementData.dataItemId + "' attribute");
          }

          var link = {
            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
          }; // add to result

          result.links.push(link); // get original link text (the one inside <a> tag)

          var linkText = element.innerHTML;
          var linkResult = replacement.getLinkResult(link.dataItemId, linkText);
          var useResultAsUrl = true;

          if (typeof linkResult === 'string') {
            // use result as URL
            useResultAsUrl = true;
          } else {
            useResultAsUrl = false;
          }

          if (!useResultAsUrl) {
            // replace whole link (<a> tag)
            if (linkResult) {
              // html for link is defined
              var linkHtml = linkResult.asHtml;
              element.outerHTML = linkHtml ? linkHtml : '';
              var parent_1 = element.parentNode;

              if (parent_1) {
                parent_1.replaceChild(element, element);
              }
            }
          }

          if (useResultAsUrl) {
            // add url to link
            var hrefAttribute = element.attributes.getNamedItem('href');

            if (!hrefAttribute) {
              // href attribute is missing
              if (config.enableAdvancedLogging) {
                console.warn("Cannot set url '" + linkResult + "' because 'href' attribute is not present in the <a> tag. Please report this issue if you are seeing this. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
              }
            } else {
              // get link url
              var linkUrlResult = typeof linkResult === 'string' ? linkResult : linkResult.asUrl;
              hrefAttribute.value = linkUrlResult ? linkUrlResult : '';
            }
          }
        } // process images


        if (element.nodeName.toLowerCase() === parser_configuration_1.parserConfiguration.imageElementData.nodeName.toLowerCase()) {
          var dataImageIdAttribute = element.attributes.getNamedItem(parser_configuration_1.parserConfiguration.imageElementData.dataImageId); // continue only if data image id is present. There could be regular img tags included

          if (dataImageIdAttribute) {
            var imageObj = {
              imageId: dataImageIdAttribute.value
            };
            result.images.push(imageObj); // get image result

            var imageResult = replacement.getImageResult(imageObj.imageId, fieldName); // get src attribute of img tag

            var srcAttribute = element.attributes.getNamedItem(parser_configuration_1.parserConfiguration.imageElementData.srcAttribute);

            if (!srcAttribute) {
              throw Error("Attribute '" + parser_configuration_1.parserConfiguration.imageElementData.srcAttribute + "' is missing. Source field: " + fieldName);
            } // set new image url


            srcAttribute.value = imageResult.url;
          }
        } // recursively process child nodes


        if (element.children && element.children.length > 0) {
          this.processRichTextField(fieldName, element.children, replacement, config, result);
        }
      }
    }

    return result;
  };

  return BrowserRichTextParser;
}();

exports.BrowserRichTextParser = BrowserRichTextParser;